import type { Article } from '@/mocks/articles';

export function formatNum(n: number): string {
  if (n >= 100000) return `${(n / 10000).toFixed(1)}万`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export const channelName: Record<string, string> = {
  tech: '科技大厂',
  platform: '互联网与平台',
  finance: '金融与投行',
  consumer: '消费与零售',
  health: '医疗与大健康',
  career: '职场观察',
};

export const verifiedMeta: Record<string, { label: string; cls: string }> = {
  verified: { label: '已核实', cls: 'bg-accent-100 text-accent-900 border-accent-200' },
  pending: { label: '待核实', cls: 'bg-secondary-200 text-secondary-900 border-secondary-300' },
  update: { label: '持续更新', cls: 'bg-primary-100 text-primary-800 border-primary-200' },
};

export function VerifiedBadge({ status }: { status: Article['verified'] }) {
  const meta = verifiedMeta[status];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${meta.cls}`}
    >
      <i
        className={status === 'verified' ? 'ri-check-double-line' : status === 'pending' ? 'ri-time-line' : 'ri-refresh-line'}
        aria-hidden="true"
      ></i>
      {meta.label}
    </span>
  );
}